if (!customElements.get('multicolumn-hover-section')) {
  customElements.define('multicolumn-hover-section', class MulticolumnHoverSection extends HTMLElement {
    connectedCallback() {
      this._onTouchStart = this._onTouchStart.bind(this);
      this._onTouchEnd = this._onTouchEnd.bind(this);
      this._onKeyDown = this._onKeyDown.bind(this);
      this.addEventListener('touchstart', this._onTouchStart, { passive: true });
      this.addEventListener('touchend', this._onTouchEnd);
      this.addEventListener('keydown', this._onKeyDown);
    }

    disconnectedCallback() {
      this.removeEventListener('touchstart', this._onTouchStart);
      this.removeEventListener('touchend', this._onTouchEnd);
      this.removeEventListener('keydown', this._onKeyDown);
    }

    _onTouchStart(e) {
      this._touchStartX = e.touches[0].clientX;
      this._touchStartY = e.touches[0].clientY;
    }

    _onTouchEnd(e) {
      if (this._touchStartX === undefined || !e.changedTouches || !e.changedTouches[0]) return;
      const dx = Math.abs(e.changedTouches[0].clientX - this._touchStartX);
      const dy = Math.abs(e.changedTouches[0].clientY - this._touchStartY);
      if (dx > 10 || dy > 10) return;

      const card = e.target.closest('.multicolumn-hover-card');
      if (!card) return;

      this._toggleCard(card);
      e.preventDefault();
    }

    _onKeyDown(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const card = e.target.closest('.multicolumn-hover-card');
      if (!card) return;
      e.preventDefault();
      this._toggleCard(card);
    }

    _toggleCard(card) {
      const isOpen = card.classList.contains('is-open');

      this.querySelectorAll('.multicolumn-hover-card.is-open').forEach((c) => {
        c.classList.remove('is-open');
        c.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        card.classList.add('is-open');
        card.setAttribute('aria-expanded', 'true');
      }
    }
  });
}
